// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"2e926f3f","455":"ba0306d1","812":"2879d475","977":"240addac"}[chunkId] + ".chunk.js";
};